import {Enable2FaFormState} from './Enable2Fa-State'
import {errorsList, errorsPresent, mergeServerValidationErrors} from '../../helpers/ErrorHelper'
import {endOfURL} from '../../helpers/UrlHelper'
import {isObject} from "../../helpers/DataHelper";

export default function enable2FaReducer(state = Enable2FaFormState, action) {

    let {data} = {...state};
    let {validationErrors, name, value, price, mode,countryCode, contactNumber} = action;
    switch (action.type) {

        case 'ON-ENABLE-2FA-FORM-CHANGE':
            data.payload[name] = value;
            buildErrors();
            return {...state, data};

        case 'SET-DEFAULT-ENABLE-2FA-FORM':
            data = {
                payload: {
                    country_code: countryCode,
                    contact_number: contactNumber,
                },
                errors: [],
                errorsPresent: false,
                submitted: false,
                dispatchAPI: false,
                mode: endOfURL(),
                message: ``
            };
            buildErrors();
            return {...state, data};

        case 'CANCEL-ENABLE-2FA-FORM-DISPATCH':
            data.dispatchAPI = false;
            data.submitted = false;
            buildErrors();
            return {...state, data};

        case 'ON-ENABLE-2FA-FORM-SUBMIT':
            data.submitted = true;
            buildErrors();
            if (!data.errorsPresent) data.dispatchAPI = true;
            return {...state, data};


        case 'ENABLE-2FA-FORM-SERVER-VALIDATION-ERRORS':
            validationErrors && isObject(validationErrors) &&
            Object.keys(validationErrors).map(key =>
                data.errors[key] = [{message: ` - ${validationErrors[key][0]}`.slice(0, -1)}]
            );
            data.errorsPresent = true;
            data.dispatchAPI = false;
            return {...state, data};

        default:
            return state
    }

    function buildErrors() {
        data.errors = errorsList(errors)
        data.errorsPresent = errorsPresent(errors)
    }

    function errors(field) {
        let {payload, submitted, validationErrors} = data;
        let errors = {};
        Object.keys(payload).map(key => errors[key] = []);

        if (submitted) {
            if (field === `country_code`) {
                if (!_(field)) newError(field, 0, `This is required field`)
            }
            if (field === `contact_number`) {
                if (!_(field)) newError(field, 0, `This is required field`)
            }
        }

        errors = mergeServerValidationErrors(errors, validationErrors)

        return field ? errors[field] : errors

        function newError(field, step, message) {
            errors && errors[field].push({step, message})
        }

        function _(field) {
            return data.payload[field]
        }
    }
}